import {environment} from '../../environments/environment';
import {HttpClientModule, HttpClient, HttpParams} from '@angular/common/http';
import {of, Observable, ObservableInput} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {ConfigService} from '../Services/config/config.service';

export function WebAppConfiguration(http: HttpClient, config: ConfigService): (() => Promise<boolean>) {
    return (): Promise<boolean> => {
        return new Promise<boolean>((resolve: (a: boolean) => void): void => {
            const configurationsURL = environment.apiUrl.baseUrl + environment.apiUrl.services.configurations;
            const countryCode = 'GB';
            const options = {
                params: new HttpParams().set('country_code', countryCode)
                    .set('cache-control', new Date().getTime() as any)
            };
            http.get(configurationsURL, options)
                .pipe(
                    map((x: ConfigService) => {
                        config.configurations = x.configurations;
                        config.personal_messages = x.personal_messages;
                        config.regions = x.regions;
                        resolve(true);
                    }),
                    catchError((x: { status: number }, caught: Observable<void>): ObservableInput<{}> => {
                        if (x.status !== 404) {
                            console.error('configurations returned with 404');
                            resolve(false);
                        }
                        // config.baseUrl = 'http://localhost:8080/api';
                        // console.log("error");
                        // console.log(x);
                        resolve(true);
                        return of({});
                    })
                ).subscribe();
        });
    };
}
